module.exports = __webpack_public_path__ + "static/media/stepsvgnew1.2ba74672.svg";